<template>
  <div class="header">
    <div class="main-title">
      <div class="content-head"><a href="./" class="logo">
          <div class="logo-wrap">
            <img class="img" :src="company.company_logo" alt="">
            <!-- <el-image class="img" fit="cover" :src="company.company_logo">
            </el-image> -->
          </div>
          <div class="title-text">{{company.company_name}}</div>
        </a>
        <div class="btn-group">
          <div class="lr-btn">
            <a href="http://admin.gdslzb.cn/admin/login" target="_blank">登录</a>
            <div class="el-divider el-divider--vertical"></div>
            <a href="http://admin.gdslzb.cn/admin/register" target="_blank">注册</a>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-content">
      <div :class="!searchFocus?'nav-list-wrap':''">
        <ul class="nav-list" v-if="!searchFocus">
          <li class="nav-item" :class="nav=='1'?'active':''"><a href="./">首页</a></li>
          <li class="nav-item" :class="nav=='2'?'active':''"><a href="./bidding">
              招标专区
            </a></li>
          <li class="nav-item" :class="nav=='3'?'active':''"><a href="/regulation">
              法律法规
            </a></li>
          <li class="nav-item" :class="nav=='4'?'active':''"><a href="/platform">
              电子竞价平台
            </a></li>
          <li class="nav-item" :class="nav=='5'?'active':''"><a href="/download">
              下载中心
            </a></li>
          <li class="nav-item" :class="nav=='6'?'active':''"><a href="/about">
              关于我们
            </a></li>
        </ul>
      </div>
      <form method="get" action="./search" autocomplete="off" id="searchForm" class="search-box"
        :class="searchFocus?'search-box-full':'search-box-normal'">
        <input type="text" placeholder="全站搜索" class="search-txt"
          @focus="searchFocus=true" @blur="searchFocus=false" name="name" v-model="searchName"><a href="#" class="search-btn"><img
            src="@/assets/images/icon-search.png" width="22px" height="22px"></a>
      </form>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";
  export default {
    name: "myhead",
    props:{
      nav:{
        type:String,
        default:'1',
      },
      project: {
        is_loading: false,
        page: {
          limit: 7,
          total: 0,
          pages: 1,
          current: 1
        },
        list: []
      },
    },
    data() {
      return {
        searchFocus: false,
        company:{},
        searchName:''
      };
    },
    mounted() {
      this.init()
    },
    methods:{
      ...mapActions({
        getConfigCompany: "index/getConfigCompany",
        getHomeSearch: "index/getHomeSearch",
      }),
      init(){
        this.getConfigCompany({
          data:{},
          success:(res) => {
            if(res.code == 1){
              this.company = res.data
            }
          },
        })
      },
      
    }
  }
</script>

<style scoped>
  a {
    text-decoration: none;
    color: inherit;
  }

  .header {
    color: #fff;
    background: #FFF;
  }

  .header .main-title {
    background: #f5f8fc;
    height: 62px;
    position: relative;
    line-height: 62px;
  }

  .header .content-head {
    width: 1200px;
    margin: 0 auto;
    position: relative;
  }

  .header .main-title .logo {
    display: inline-block;
    height: 62px;
  }

  .header .main-title .logo .logo-wrap {
    max-height: 40px;
    width: 45px;
    vertical-align: top;
    display: inline-block;
    margin-right: 10px;
    
  }

  .header .main-title .logo .logo-wrap .img {
    max-height: 40px;
    width: 45px;
    top: 50%;
    position: relative;
    transition: all 1s;
    vertical-align: middle;
  }
  
  .image-slot{
    color: #000 !important;
  }

  .header .main-title .logo .title-text {
    color: #272727;
    font-size: 26px;
    display: inline-block;
    line-height: 62px;
  }

  .header .main-title .btn-group {
    float: right;
    height: 62px;
    position: relative;
  }

  .header .main-title .btn-group .lr-btn {
    width: 136px;
    height: 38px;
    position: relative;
    top: 50%;
    transform: translatey(-50%);
    background: linear-gradient(180deg,#0080FF 0,#0080FF 100%);
    line-height: 38px;
    text-align: center;
    border-radius: 2px;
  }

  .header .nav-content {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 0 auto;
  }

  .header .nav-list-wrap {
    width: 1005px;
    height: 82px;
    display: inline-block;
    color: #1B1B1B;
  }

  .header .nav-list-wrap .nav-list {
    display: inline-block;
    height: 82px;
  }

  .header .nav-list-wrap .nav-list .active {
    background: url(../../assets/images/icon-underline.png) no-repeat bottom;
    color: #0080FF;
  }
  .header .nav-list-wrap .nav-list .nav-item:hover{
    background: url(../../assets/images/icon-underline.png) no-repeat bottom;
    color: #0080FF;
  }

  .header .nav-list-wrap .nav-list li {
    cursor: pointer;
    display: inline-block;
    text-align: center;
    width: 96px;
    height: 82px;
    margin: 0 34px;
    /* padding: 30px 0; */
  }

  .header .nav-list-wrap .nav-list li a {
    font-size: 16px;
    font-weight: 700;
    height: 82px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header .search-box {
    position: relative;
    margin: 18px 0 18px 0;
    height: 24px;
    background: #fffdfd;
    border-radius: 40px;
    padding: 10px 25px 10px 10px;
    border: 1px solid #d6d3d3;
    width: 110px;
    float: right;
  }

  .header .search-box-full {
    width: 1200px;
    transition: all ease .8s;
  }

  .header .search-txt {
    border: none;
    background: 0 0;
    outline: 0;
    height: 24px;
    line-height: 24px;
    color: #000;
    font-size: 16px;
    width: 100%;
  }

  .header .search-btn {
    position: absolute;
    pointer-events: none;
    right: 6px;
  }
</style>
<style>
  .el-pager li.active{
    color: #0080FF;
  }
</style>